import { Box, Grid } from "@mui/material";
import LoaderExplorer from "../../components/organisms/loaderExplorer/LoaderExplorer";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getRoleClaimsSelector } from "../../store/auth/selectors";

const DataLoaderList = () => {

    const { targetName, extractorBatchCode } = useParams();

    const roles = useSelector(getRoleClaimsSelector);  // roles  - IDP.Admin or IDP.User

    const [isAdmin, setIsAdmin] = useState(true);
    useEffect(() => {
        if (roles && roles.length > 0) {
            setIsAdmin(roles.includes("IDP.Admin") ? true : false);
        }
    }, [roles]);

    return (
        <>
            <Box sx={{ paddingBottom: "10px" }}>
                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                    <Grid item xs={12}>
                        <h1 style={{ textAlign: "left" }}>Data Loaders</h1>
                    </Grid>
                </Grid>
            </Box>            
            <LoaderExplorer selectable={"no"} targetName={targetName} extractorBatchCode={extractorBatchCode} isAdmin={isAdmin} displayActionButtons={true} />
        </>
    )
}

export default DataLoaderList;